<template>
<div>
    <BreadCrumb class="bread" :breads="['设备管理','理货任务']"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">理货任务</span>
            <router-link :to="{path:'/index/restock'}">
                <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
                    返回列表
                </el-button>
            </router-link>

        </div>

        <div class="MainTable">
            <div class="form">
                <el-form ref="form" size="small" class="form-container" label-width="120px" :rules="rules" :model="formData">
                    <div class="form-container__left">
                        <el-form-item label="机器编号">
                            <el-input v-model="formData.hard_number" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="线路名称">
                            <el-input v-model="formData.line_name" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="点位名称">
                            <el-input v-model="formData.point_name" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="货柜类型">
                            <span v-if="formData.bin_type ==0">单门柜</span>
                            <span v-if="formData.bin_type ==1">双门柜</span>
                        </el-form-item>
                    </div>
                    <div class="form-container__right">
                        <el-form-item label="备货日期">
                            <el-input v-model="formData.task_date" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="总数">
                            <el-input v-model="formData.total_qty" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="所属商家" prop="">
                            <span v-if="formData.under_terminal ==1">麦杰思</span>
                            <span v-if="formData.under_terminal ==2">轻购云</span>
                        </el-form-item>
                    </div>
                </el-form>

                <el-button size="small" type="primary" @click="addGoods" v-if="!look">新增商品</el-button>
            </div>

            <el-table :data='tableList' stripe id="MainTables" style="width: 100%" v-loading="loading">
                <div style="margin-bottom: 15px;">
                    <el-radio-group v-model="threshold" @change="loadDisplayList">
                        <el-radio :label="1">缺货陈列</el-radio>
                        <el-radio :label="2">获取全部</el-radio>
                    </el-radio-group>
                </div>

                <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                <el-table-column prop="barcode" label="条形号" align="center">
                </el-table-column>
                <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.image_url" width="40px;" height="40px;" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称" align="center">
                </el-table-column>
                <el-table-column prop="real_price" label="价格" align="center">
                </el-table-column>
                <el-table-column prop="details_qty" label="补货数量" align="center">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.details_qty" @input="syncDetailsQty(scope.row, $event)"></el-input>
                    </template>
                </el-table-column>

                <el-table-column prop="bin_type" label="设备类型" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.bin_no==0" style="color:green">单开门</div>
                        <div v-if="scope.row.bin_no==1" style="color:blue">左门</div>
                        <div v-if="scope.row.bin_no==2" style="color:blue">右门</div>
                    </template>
                </el-table-column>
                <el-table-column prop="bin_type" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" v-if="!look" @click="modifyItem(scope.row,scope.$index)">修改</el-button>
                        <el-button type="text" size="mini" v-if="!look" @click="removeItem(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div style="width: 100%;margin:20px auto;text-align: center;">
            <el-button class="backList" type="primary" size="small" v-if="!look" @click="confirmModify">确 定</el-button>
        </div>

    </div>

    <el-dialog class="dialogMY" :visible.sync="showDialog" width="80%" center>
        <div style="margin-bottom: 15px;">
            <el-radio-group v-model="threshold" @change="loadDisplayList">
                <el-radio :label="1">缺货陈列</el-radio>
                <el-radio :label="2">获取全部</el-radio>
            </el-radio-group>
        </div>
        <el-table :data="itemList" stripe style="width: 100%">
            <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
            <el-table-column label="图片">
                <div slot-scope="scope">
                    <img :src="scope.row.image_url" width="80px" height="80px" />
                </div>
            </el-table-column>
            <el-table-column prop="name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="barcode" label="条形码" align="center">
            </el-table-column>
            <el-table-column prop="qty" label="容量" align="center">
            </el-table-column>
            <el-table-column prop="real_price" label="单价" align="center">
            </el-table-column>
            <el-table-column prop="details_qty" label="需要补货数量" align="center">
            </el-table-column>
            <el-table-column prop="real_qty" label="真实数量" align="center">
            </el-table-column>
            <el-table-column prop="bin_type" label="设备类型" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.bin_type ==0">单开门</div>
                    <div v-if="scope.row.bin_type ==1">左门</div>
                    <div v-if="scope.row.bin_type ==2">右门</div>
                </template>
            </el-table-column>
            <el-table-column prop="bin_type" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="primary" @click="confirmAdd(scope.row.barcode)">新增选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="showDialog = false">关闭弹窗</el-button>
        </span>
    </el-dialog>

    <el-dialog class="dialogMY" :visible.sync="showModifyDialog" width="80%" center>
        <div style="margin-bottom: 15px;">
            <el-radio-group v-model="threshold" @change="loadDisplayList">
                <el-radio :label="1">缺货陈列</el-radio>
                <el-radio :label="2">获取全部</el-radio>
            </el-radio-group>
        </div>
        <el-table :data="itemList" stripe style="width: 100%">
            <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
            <el-table-column label="图片">
                <div slot-scope="scope">
                    <img :src="scope.row.image_url" width="80px" height="80px" />
                </div>
            </el-table-column>
            <el-table-column prop="name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="barcode" label="条形码" align="center">
            </el-table-column>
            <el-table-column prop="qty" label="容量" align="center">
            </el-table-column>
            <el-table-column prop="real_price" label="单价" align="center">
            </el-table-column>
            <el-table-column prop="details_qty" label="需要补货数量" align="center">
            </el-table-column>
            <el-table-column prop="real_qty" label="真实数量" align="center">
            </el-table-column>
            <el-table-column prop="bin_type" label="设备类型" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.bin_type ==0">单开门</div>
                    <div v-if="scope.row.bin_type ==1">左门</div>
                    <div v-if="scope.row.bin_type ==2">右门</div>
                </template>
            </el-table-column>
            <el-table-column prop="bin_type" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="primary" @click="selectModify(scope.row)">修改选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="showDialog = false">关闭弹窗</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SimplePrint from "@/components/SimplePrint";
import apis from "@/config/apis";
import {
    download
} from "@/plugins/util";
import listMixin from "@/mixins/list";
export default {
    name: "PointManagement",
    mixins: [listMixin],
    data() {
        return {
            Rem: 1,
            search: {
                page_index: 1,
                page_size: 10,
                under_terminal: 1
            },
            QGList: [],
            MAGEXList: [],
            tableList: [],
            itemList: [],
            originList: [],
            row_id: "",
            showDialog: false,
            showModifyDialog: false,
            currentModifyRow: "",
            currentModifyIndex: null,
            removeData: "",
            look: false,
            threshold: 1, // 默认缺货陈列
            formData: {

            }

        };
    },
    created() {
        if (this.$route.query.operate == 'look') {
            this.look = true;
        }

        this.getData();
    },
    methods: {
        async getData() {

            this.$axios.get(apis.stock_up_task + this.$route.query.id + '/')
                .then(res => {
                    this.formData = res.data.data;
                    const data = res.data.data.items || []

                    // ✅ 第一步：统一为每一条数据添加 state=3
                    const withState = data.map(item => ({
                        ...item,
                        state: 3
                    }))

                    // ✅ 第二步：深拷贝一份到 originList（提交时用）
                    this.originList = JSON.parse(JSON.stringify(withState))

                    // ✅ 第三步：过滤掉 state=2 的用于页面显示
                    this.tableList = withState.filter(item => item.state !== 2)

                    console.log(this.tableList, '显示数据')
                    console.log(this.originList, '提交数据')
                })

        },
        // onStateChange(val) {
        //     console.log("当前选择：", val);

        //     if (val === '1') {
        //         this.threshold = 1;
        //         this.state = '1';
        //         this.addGoods();

        //     } else if (val === '2') {
        //         this.state = '2';
        //         this.threshold = 2;
        //         this.addGoods();

        //     }
        // },
        onStateModifyChange(val) {
            if (val === '1') {
                this.state1 = '1';
                this.threshold = 1;

                this.modifyItem();

            } else if (val === '2') {
                this.state1 = '2';
                this.threshold = 2;
                this.modifyItem();

            }
        },

        syncDetailsQty(row, val) {
            // 确保 val 有值（el-input 的 @input 会传新值）
            const newVal = val === undefined ? row.details_qty : val;

            // 选唯一键：优先用 id 存在时匹配，否则用 barcode
            const key = row.id !== undefined ? 'id' : 'barcode';
            const keyVal = row[key];

            const originIndex = this.originList.findIndex(item => item[key] === keyVal);
            if (originIndex === -1) {
                // originList 中没有，可能是意外 —— 可选择 push（下面代码为安全方案）
                const copy = Object.assign({}, row, {
                    details_qty: newVal
                });
                this.originList.push(copy);
                return;
            }

            // 使用 Vue.set 或 this.$set 保证响应式（Vue2）
            this.$set(this.originList[originIndex], 'details_qty', newVal);
        },
        submitData() {
            // 组装提交结构
            const payload = {
                terminals: [{
                    items: this.tableList.map((item) => ({
                        barcode: item.barcode,
                        bin_no: item.bin_no,
                        details_qty: item.details_qty,
                        image_url: item.image_url,
                        name: item.name,
                        real_price: item.real_price,
                        state: item.state, // 提交时带上 state 状态
                    })),
                }, ],
            };
        },
        // 🗑 删除逻辑
        removeItem(index, row) {
            this.$confirm(`确定删除 ${row.name || row.barcode || '该商品'} 吗？`, '提示', {
                    type: 'warning'
                })
                .then(() => {
                    // 1. 从 tableList UI 上移除（splice）
                    this.tableList.splice(index, 1);

                    // 2. 在 originList 中定位对应项（用唯一键：优先用 id，其次用 barcode）
                    const keyId = row.id !== undefined ? 'id' : 'barcode';
                    const keyValue = row[keyId];

                    const originIndex = this.originList.findIndex(it => it[keyId] === keyValue);

                    if (originIndex === -1) {
                        // 如果 originList 找不到（理论上不会），则返回或打印
                        console.warn('originList 中未找到该项，可能是已被移除或 key 不一致', row);
                        return;
                    }

                    const originItem = this.originList[originIndex];

                    // 3. 如果是前端新建的（state === 1），直接从 originList里移除
                    if (originItem.state === 1) {
                        this.originList.splice(originIndex, 1);
                    } else {
                        // 4. 否则标记为删除（state = 2）
                        // 使用 Vue.set 保证响应式（如果你需要观察 originList）
                        this.$set(this.originList, originIndex, {
                            ...originItem,
                            state: 2
                        });
                    }

                    this.$message.success('已删除');
                })
                .catch(() => {
                    // 取消删除
                });
        },

        confirmAdd(barcode) {
            // 1️⃣ 在 originList 中查找是否存在相同条码
            const originIndex = this.originList.findIndex(item => item.barcode === barcode);
            const originItem = this.originList[originIndex];

            // 🔍 在 tableList 中查找是否存在相同条码（UI显示用）
            const tableExist = this.tableList.find(item => item.barcode === barcode);

            // 2️⃣ 如果 UI 中存在并且不是删除状态（正常显示）→拒绝新增
            if (tableExist) {
                this.$message.warning(`条形码 ${barcode} 已存在，无法重复添加`);
                return;
            }

            // 3️⃣ 如果 originList 中存在且 state=2（已删除），则恢复为新增
            if (originItem && originItem.state === 2) {
                // 恢复为新增
                const restored = {
                    ...originItem,
                    state: 1 // 恢复为新增
                };

                // UI 显示
                this.tableList.push(restored);

                // 更新 originList 状态
                this.$set(this.originList, originIndex, restored);

                this.$message.success(`条形码 ${barcode} 恢复到新增状态`);
                return;
            }

            // 4️⃣ originList 中没有 → 真正的新增
            const source = this.itemList.find(item => item.barcode === barcode);
            if (!source) {
                this.$message.error(`未找到条码 ${barcode} 对应的商品`);
                return;
            }

            // 构造新增结构
            const newItem = {
                barcode: source.barcode,
                bin_no: source.bin_no,
                image_url: source.image_url,
                name: source.name,
                real_price: source.real_price,
                details_qty: source.details_qty || 1,
                state: 1 // 新增
            };

            // UI push
            this.tableList.push(newItem);

            // originList push
            this.originList.push(JSON.parse(JSON.stringify(newItem)));

            this.$message.success(`条形码 ${barcode} 已添加`);
        },

        // selectModify(newItem) {
        //     console.log(newItem,'res')
        //     const oldRow = this.currentModifyRow;

        // 1. 判断是否重复条码
        // const exist = this.tableList.some(item =>
        //     item.barcode === newItem.barcode && item !== oldRow
        // );
        // if (exist) {
        //     this.$message.warning(`条形码 ${newItem.barcode} 已存在，无法重复修改`);
        //     return;
        // }

        // // 2. 保存 oldRow 到替换记录（保留它自己的 state）
        // this.replacedList = this.replacedList || []; // 预防 undefined
        // this.replacedList.push({
        //     ...oldRow,
        //     state: oldRow.state
        // });

        // // 3. originList 同步处理（如果是后台来的记录）
        // const origin = this.originList.find(o => o.id === oldRow.id);
        // if (origin) {
        //     if (origin.state === 2) {
        //         origin.state = 3; // 被删除后又回来 → 状态改为 3
        //     }

        //     origin.barcode = newItem.barcode;
        //     origin.name = newItem.name;
        //     origin.real_price = newItem.real_price;
        //     origin.image_url = newItem.image_url;
        //     origin.bin_no = newItem.bin_no || 0;
        // }

        // // 4. 替换 tableList 的当前行
        // const updated = {
        //     ...oldRow,
        //     barcode: newItem.barcode,
        //     name: newItem.name,
        //     real_price: newItem.real_price,
        //     image_url: newItem.image_url,
        //     bin_no: newItem.bin_no || 0,
        //     state: oldRow.state // ⭐ 保留旧状态
        // };

        // const index = this.tableList.findIndex(i => i === oldRow);
        // this.$set(this.tableList, index, updated);

        // this.$message.success("商品修改成功");
        // this.modifyDialogVisible = false;
        // },

        selectModify(newItem) {
            const oldRow = this.currentModifyRow;

            // ========== 1. 检查是否与其他行重复 ==========
            const exist = this.tableList.some(item =>
                item.barcode === newItem.barcode && item !== oldRow
            );

            if (exist) {
                this.$message.warning(`条形码 ${newItem.barcode} 已存在，无法重复修改`);
                return;
            }

            // ========== 2. originList 同步处理(支持被删除又恢复) ==========
            // 查找是否为后台原始的那一条
            const origin = this.originList.find(o => o.id === oldRow.id);

            if (origin) {
                // 若 origin 被删除过(state=2)，修改后恢复为 3
                if (origin.state === 2) origin.state = 3;

                // 同步 originList 的字段
                origin.barcode = newItem.barcode;
                origin.name = newItem.name;
                origin.details_qty = newItem.details_qty,
                    origin.real_price = newItem.real_price;
                origin.image_url = newItem.image_url;
                origin.bin_no = newItem.bin_no || 0;
            }

            // ========== 3. 替换 tableList 的内容（要强制触发响应式） ==========
            const updated = {
                ...oldRow,
                barcode: newItem.barcode,
                name: newItem.name,
                details_qty: newItem.details_qty,
                real_price: newItem.real_price,
                image_url: newItem.image_url,
                bin_no: newItem.bin_no || 0,
                state: oldRow.state // 🔥 修改不改变 state（仍是 3）
            };

            // 让 Vue 检测到变化（Vue2 必须用这种方式）
            const index = this.tableList.findIndex(i => i === oldRow);
            this.$set(this.tableList, index, updated);

            this.$message.success("商品修改成功");
            this.modifyDialogVisible = false;
        },

        addGoods() {
            this.showDialog = true;
            this.loadDisplayList();
            // let jsonData = {
            //     hard_number: this.formData.hard_number,
            //     under_terminal: this.formData.under_terminal,
            //     bin_type: this.formData.bin_type,
            //     threshold: this.threshold,

            // }
            // this.$axios.post(apis.equipment_display, jsonData).then(res => {
            //     this.showDialog = true;
            //     this.itemList = res.data.data;
            // })
        },
        modifyItem(row, index) {
            this.currentModifyRow = row;
            this.currentModifyIndex = index;
            this.showModifyDialog = true;
            this.loadDisplayList();

            // this.currentModifyRow = row; // 记录当前被修改的行（引用）
            // let jsonData = {
            //     hard_number: this.formData.hard_number,
            //     under_terminal: this.formData.under_terminal,
            //     bin_type: this.formData.bin_type,
            //     threshold: this.threshold ? this.threshold : 1,

            // }
            // this.$axios.post(apis.equipment_display, jsonData).then(res => {
            //     this.showModifyDialog = true;
            //     this.itemList = res.data.data;
            // })
        },
        loadDisplayList() {
            let jsonData = {
                hard_number: this.formData.hard_number,
                under_terminal: this.formData.under_terminal,
                bin_type: this.formData.bin_type,
                threshold: this.threshold
            };

            this.$axios.post(apis.equipment_display, jsonData).then(res => {
                this.itemList = res.data.data;
            });
        },

        confirmModify() {
            const payload = this.originList.map(item => ({
                barcode: item.barcode,
                bin_no: item.bin_no,
                details_qty: item.details_qty,
                image_url: item.image_url,
                name: item.name,
                real_price: item.real_price,
                state: item.state,
            }))

            let jsonData = {
                items: payload
            }
            this.$axios.put(apis.stock_up_task + this.$route.query.id + '/', jsonData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('修改成功')
                }
                this.$router.push({
                    name: 'restock'
                })

            })
        },

    },
    components: {
        BreadCrumb,
        SimplePrint
    }
};
</script>

<style lang="scss" scoped>
/*弹窗*/
.el-icon-warning {
    color: #e6a23c;
    font-size: 60px;
}

.Main {
    text-align: center;

    .infoOne {
        font-size: 28px;
        line-height: normal;
    }

    .infoTwo {
        padding-top: 10px;
        font-size: 14px;
    }
}
</style>
